import { StepIconProps } from '@mui/material';
import React from 'react'
import { ColorlibStepIconRoot } from 'shared/utils';
import Images from 'shared/assets/index'
import { ITimeLine } from '../Models/ITimeLine';
import {useState} from 'react';
import _ from 'lodash';

interface Props{
  timeLine: ITimeLine
}

export const useStepper = ({timeLine}:Props) => {

  const [seeTimeLine, setSeeTimeLine] = useState<any>({
    receivedAt: !!timeLine.receivedAt,
    cancelledAt: !!timeLine.cancelledAt,
    filedAt: !!timeLine.filedAt,
    conciliationAt: !!timeLine.conciliationAt,
    authorizedToPaymentAt: !!timeLine.authorizedToPaymentAt,
    paidAt: !!timeLine.paid_at,
  })

    const changeSeeTimeLine = () => {
      const newObject = Object.assign({}, seeTimeLine);

      for (let prop in newObject) {
        if (newObject.hasOwnProperty(prop) && !newObject[prop]) {
          newObject[prop] = true
          break
        }
      }
      !_.isEqual(seeTimeLine, newObject) && setSeeTimeLine({...newObject})
      
    }

    const ColorlibStepIcon = (props: StepIconProps)=> {
        const { active, completed, className } = props;
      
        // Definir iconos para cada paso del stepper
        const stepIcons: { [key: number]: JSX.Element } = {
          1: <img src={Images.iconoDescarga} alt='Recibida' style={{ width: '21px', height: '21px', filter: 'brightness(0) invert(1)' }} />,
          2: <img src={Images.iconoNulo} alt='Anulada' style={{ width: '21px', height: '21px', filter: 'brightness(0) invert(1)' }} />,
          3: <img src={Images.iconoCheck} alt='Radicada' style={{ width: '21px', height: '21px', filter: 'brightness(0) invert(1)' }} />,
          4: <img src={Images.iconoPago} alt='Conciliación' style={{ width: '21px', height: '21px', filter: 'brightness(0) invert(1)' }} />,
          5: <img src={Images.iconoManos} alt='Autorizada' style={{ width: '21px', height: '21px', filter: 'brightness(0) invert(1)' }} />,
          6: <img src={Images.iconoMonedas} alt='Aprobada' style={{ width: '21px', height: '21px', filter: 'brightness(0) invert(1)' }} />,
        };
      
        return (
          <ColorlibStepIconRoot
            ownerState={{ completed, active }}
            className={className}
          >
            {stepIcons[Number(props.icon)]}
          </ColorlibStepIconRoot>
        );
      }

      const validateCancelledAt = ()=>{
        return !!timeLine.cancelledAt && false
      }

      let steps = [
        {
          date: new Date(timeLine.receivedAt!),
          label: "Recibida",
          active: seeTimeLine.receivedAt && !!timeLine.receivedAt,
          completed: seeTimeLine.receivedAt && !!timeLine.receivedAt
      },
      {
          date: timeLine.cancelledAt ? new Date(timeLine.cancelledAt) : null,
          label: "Anulada",
          active: seeTimeLine.cancelledAt && ( !!timeLine.cancelledAt || !!timeLine.filedAt),
          completed: seeTimeLine.cancelledAt &&  !!timeLine.cancelledAt
      },
      {
          date: new Date(timeLine.filedAt!),
          label: "Radicada",
          active: seeTimeLine.filedAt && ( validateCancelledAt() || !!timeLine.filedAt || !!timeLine.conciliationAt || !!timeLine.authorizedToPaymentAt),
          completed: seeTimeLine.filedAt && ( validateCancelledAt()|| !!timeLine.filedAt || !!timeLine.conciliationAt || !!timeLine.authorizedToPaymentAt)
      },
      {
          date: new Date(timeLine.conciliationAt!),
          label: "Conciliación",
          active: seeTimeLine.conciliationAt && ( validateCancelledAt() || !!timeLine.conciliationAt || !!timeLine.authorizedToPaymentAt ),
          completed: seeTimeLine.conciliationAt && ( validateCancelledAt() || !!timeLine.conciliationAt || !!timeLine.authorizedToPaymentAt)
      },
      {
          date: new Date(timeLine.authorizedToPaymentAt!),
          label: "Autorizada",
          active: seeTimeLine.authorizedToPaymentAt && ( validateCancelledAt() || !!timeLine.authorizedToPaymentAt  || !!timeLine.paid_at),
          completed: seeTimeLine.authorizedToPaymentAt && ( validateCancelledAt() || !!timeLine.authorizedToPaymentAt || !!timeLine.paid_at)
      },
      {
          date: new Date(timeLine.paid_at!),
          label: "Pagada",
          active: seeTimeLine.paidAt && ( validateCancelledAt() || !!timeLine.paid_at),
          completed: seeTimeLine.paidAt && ( validateCancelledAt() || !!timeLine.paid_at)
      },
  ];
  steps = steps.filter(step=> step.date !== null);

  const sortSteps = steps.findIndex(item => item.label === "Factura Anulada");
  
  (sortSteps !== -1) && steps.sort((a:any, b:any) => a.date - b.date);

  return {
    ColorlibStepIcon,
    changeSeeTimeLine,
    steps,
    seeTimeLine

  }
}
